<template>
  <div class="warning-panel" :class="{ 'is-severe': severe }">
    <ErrorIcon class="icon" />
    <div class="title-wrap">
      <slot name="title">
        <span class="title">{{ title }}</span>
      </slot>
    </div>
    <div class="message">
      <slot name="message">
        {{ msg }}
      </slot>
    </div>
  </div>
</template>

<script>
import ErrorIcon from "@/assets/svg/icon-form-error.svg";

export default {
  name: "WarningPanel",
  props: {
    title: String,
    msg: String,
    severe: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ErrorIcon,
  },
};
</script>

<style lang="scss" scoped>
.warning-panel {
  display: grid;
  grid-template-columns: min-content auto;
  grid-template-rows: auto auto;
  grid-column-gap: $spacing-small;

  background-color: $white;
  border: 2px solid $brand-blue;
  border-radius: $border-radius-large;
  box-shadow: $brand-box-shadow;

  padding: $spacing-xs $spacing-small;
  margin: $spacing-medium 0;

  &.is-severe {
    color: $error;
    background-color: lighten($error, 70%);
    border: 2px solid $error;
  }

  .icon {
    width: 36px;
    fill: $error;

    grid-column: 1;
    grid-row: 1 / 3;
  }

  .title-wrap {
    align-self: end;
  }

  .title {
    text-align: start;
    font-weight: $font-bold;

    margin: 0;
    color: inherit;
  }

  .message {
    font-size: 18px;
  }
}

//.content-panel {
//  position: relative;
//  padding-left: 30px;
//  margin: 30px 0;
//
//  &.is-severe {
//    color: $error;
//    background-color: lighten($error, 70%);
//    border: 1px solid $error;
//  }
//
//  .no-title {
//    display: flex;
//
//    svg {
//      flex-shrink: 0;
//    }
//
//    p {
//      margin-left: $spacing-small;
//    }
//  }
//}
//
//.content-panel__error-icon {
//  top: 25px;
//  left: 15px;
//}
//
//h2 {
//  font-size: 1.6rem;
//  margin: 0 0 $spacing-tiny $spacing-tiny;
//}
//
//p {
//  font-size: 1.6rem;
//  margin: 0;
//}
</style>
